module.exports = __webpack_public_path__ + "static/img/pzBtn.604a778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pzBtn.png
// module id = 91C2
// module chunks = 1